module.exports = {
  __init__: [ 'selectionVisuals', 'selectionBehavior' ],
  __depends__: [
    require(47),
    require(49)
  ],
  selection: [ 'type', require(52) ],
  selectionVisuals: [ 'type', require(54) ],
  selectionBehavior: [ 'type', require(53) ]
};
